import React from "react";
import { trackPageView } from "shared/utils/hubspot";
import Payment from "./pages/Payment";
import Subscription from "./pages/Subscription";
import TrialSubscription from "./pages/TrialSubscription";
import WaitingForSystemOneToCreateAccount from "./pages/WaitingForSystemOneToCreateAccount";
import YourDetails from "./pages/YourDetails";
import Steps from "./Steps";

const Onboarding = ({ viewModel }: { viewModel: server.viewmodel.ClientOnboardingLandingFrontModel }) => {
  const [session, setSession] = React.useState<server.dto.ClientOnboardingSession>(viewModel.session);

  const isLifecycle = (lifecycle: server.dto.ClientOnboardingLifeCycles) => session.lifeCycle === lifecycle;

  const onNextPage = (newSession: server.dto.ClientOnboardingSession) => {
    trackPageView(newSession.lifeCycle);
    setSession(newSession);
  };

  const onLifecycleChanged = async (newLifecycle: server.dto.ClientOnboardingLifeCycles) => {
    await window.CoreApi.ClientOnboardingOpen.SetLifecycle({
      secret: session.secret,
      lifeCycle: newLifecycle
    });

    const newSession = await window.CoreApi.ClientOnboardingOpen.GetOnboardingSession(session.secret);
    setSession(newSession.data.data);

  };

  return <div className="s1_main-panel large">
    <Steps
      trial={session.trial}
      activeLifecycle={session.lifeCycle}
      sessionLifecycle={session.lifeCycle}
      onLifecycleChanged={onLifecycleChanged}
    />

    <div className="flex-column" style={{ flex: "6 1 auto" }}>
      {isLifecycle("setYourDetails") &&
        <YourDetails session={session} onFinished={onNextPage} />}

      {isLifecycle("configureSubscription") &&
        !session.trial &&
        <Subscription session={session} onFinished={onNextPage} />}

      {isLifecycle("configureSubscription") &&
        session.trial &&
        <TrialSubscription session={session} onFinished={onNextPage} />}

      {isLifecycle("paymentSetup") &&
        <Payment session={session} onFinished={onNextPage} />}

      {isLifecycle("readyForCreateClientAccount") &&
        <WaitingForSystemOneToCreateAccount session={session} />}
    </div>
  </div>;
};

export default Onboarding;